export type ServiceAiArtifactPreview =
  | { version: 1; kind: 'table'; caption: string; columns: string[]; rows: string[][] }
  | { version: 1; kind: 'checklist'; caption: string; items: Array<{ text: string; checked: boolean }> };

const isText = (value: unknown): value is string => typeof value === 'string' && value.length <= 500;
const isRecord = (value: unknown): value is Record<string, unknown> => Boolean(value) && typeof value === 'object' && !Array.isArray(value);

export function normalizeServiceAiArtifactPreview(value: unknown): ServiceAiArtifactPreview | null {
  if (!isRecord(value) || value.version !== 1 || !isText(value.caption)) return null;
  if (value.kind === 'table') {
    const { columns, rows } = value;
    if (!Array.isArray(columns) || columns.length < 1 || columns.length > 8 || !columns.every((column) => isText(column) && column.trim().length > 0)) return null;
    if (!Array.isArray(rows) || rows.length < 1 || rows.length > 40 || !rows.every((row) => Array.isArray(row) && row.length === columns.length && row.every(isText))) return null;
    return { version: 1, kind: 'table', caption: value.caption, columns: [...columns], rows: rows.map((row) => [...row]) };
  }
  if (value.kind === 'checklist') {
    if (!Array.isArray(value.items) || value.items.length < 1 || value.items.length > 40) return null;
    if (!value.items.every((item) => isRecord(item) && isText(item.text) && item.text.trim().length > 0 && typeof item.checked === 'boolean')) return null;
    return { version: 1, kind: 'checklist', caption: value.caption, items: value.items.map((item) => ({ text: item.text, checked: item.checked })) };
  }
  return null;
}
